export const administrationAccountsSiteLocationQualityManagerDetails = {
    template: require('./administration-accounts-site-location-quality-manager-details.html'),
    controller: 'AdministrationAccountsSiteLocationQualityManagerDetailsController'
};
